export const formatTextToHtml = (text: string): string => {
  if (!text) return '';
  
  // Si c'est déjà du HTML, on le retourne tel quel
  if (text.includes('<') && text.includes('>')) {
    return text;
  }
  
  // Convertir le texte brut en HTML en préservant la mise en page
  // Séparer par doubles sauts de ligne = paragraphes
  const paragraphs = text.split(/\n\s*\n/);
  
  const htmlParts = paragraphs.map(paragraph => {
    const lines = paragraph.trim();
    if (!lines) return '';
    
    // Préserver les espaces multiples et les sauts de ligne simples
    const formatted = lines
      .replace(/\n/g, '<br>\n')
      .replace(/  +/g, (match) => '&nbsp;'.repeat(match.length));
    
    return `<p>${formatted}</p>`;
  }).filter(Boolean);
  
  return htmlParts.join('\n');
};

export const preserveRichText = (html: string): string => {
  if (!html) return '';
  
  // Si c'est déjà du HTML bien formaté, on le garde tel quel
  if (html.includes('<') && html.includes('>')) {
    return html;
  }
  
  // Sinon on applique le formatage automatique
  return formatTextToHtml(html);
};

export const cleanPastedContent = (html: string): string => {
  // Nettoie le contenu collé en préservant tous les styles importants
  if (!html) return '';

  return html
    // Préserve les espaces non-sécables et multiples
    .replace(/&nbsp;/g, ' ')
    .replace(/\s{2,}/g, (match) => '&nbsp;'.repeat(match.length))
    
    // Préserve les balises de formatage importantes avec leurs attributs de style
    .replace(/<(h[1-6])[^>]*>/gi, '<$1>')
    .replace(/<\/(h[1-6])>/gi, '</$1>')
    
    // Préserve les balises de texte avec formatage
    .replace(/<(strong|b)[^>]*>/gi, '<strong>')
    .replace(/<\/(strong|b)>/gi, '</strong>')
    .replace(/<(em|i)[^>]*>/gi, '<em>')
    .replace(/<\/(em|i)>/gi, '</em>')
    .replace(/<(u)[^>]*>/gi, '<u>')
    .replace(/<\/(u)>/gi, '</u>')
    
    // Préserve les paragraphes et leurs espaces
    .replace(/<p[^>]*>/gi, '<p>')
    .replace(/<\/p>/gi, '</p>')
    
    // Préserve les divs comme paragraphes
    .replace(/<div[^>]*>/gi, '<p>')
    .replace(/<\/div>/gi, '</p>')
    
    // Préserve les listes
    .replace(/<(ul|ol)[^>]*>/gi, '<$1>')
    .replace(/<\/(ul|ol)>/gi, '</$1>')
    .replace(/<li[^>]*>/gi, '<li>')
    .replace(/<\/li>/gi, '</li>')
    
    // Préserve les spans avec style (pour les couleurs, etc.)
    .replace(/<span[^>]*style="[^"]*"[^>]*>/gi, (match) => {
      const styleMatch = match.match(/style="([^"]*)"/);
      return styleMatch ? `<span style="${styleMatch[1]}">` : '<span>';
    })
    .replace(/<span[^>]*>/gi, '<span>')
    .replace(/<\/span>/gi, '</span>')
    
    // Préserve les retours à la ligne
    .replace(/<br[^>]*>/gi, '<br>')
    
    // Supprime les autres balises tout en gardant le contenu
    .replace(/<[^>]+>/g, '')
    
    // Préserve les retours à la ligne du texte brut
    .replace(/\r?\n/g, '<br>')
    
    // Nettoie les espaces en trop mais préserve l'indentation
    .replace(/^\s+/gm, (match) => '&nbsp;'.repeat(match.length))
    
    // Évite les doubles <br>
    .replace(/(<br\s*\/?>){3,}/g, '<br><br>');
};